import { useGetters } from "@/store/vuex-composition-mappers";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger(useDefaultCartReWriteLocation.name);

export function useDefaultCartReWriteLocation(subPath: string) {
    // @ts-expect-error
    const { easyCartUrl } = useGetters(["easyCartUrl"]);
    return {
        gotoCartPage(queryParams?: Record<string, string>) {
            const queryString = new URLSearchParams(queryParams).toString();
            const fullURL = `${easyCartUrl.value}${subPath}${queryString ? `?${queryString}` : ""}`;
            logger.info("redirecting to cart page", fullURL);
            window.location.href = fullURL;
        },
    };
}
